import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;


export function cekAuth() {
  return {
    headers: {
        Authorization: API_KEY + localStorage.getItem("token"),
        'Content-Type':'multipart/form-data'
    }
  };
}

export function fetchUploadAll() {
    const url = `${ROOT_URL}fileupload/fileupload/`;
    const request = axios.get(url, cekAuth());
    return request;
}

export function deleteFileUpload(id) {
    const url = `${ROOT_URL}fileupload/fileupload/${id}/`;

    const request = axios.delete(url, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;
}

export function pushUpload(body) {
  const url = `${ROOT_URL}fileupload/fileupload/`;

  const fdata = new FormData();
  fdata.append('company_code', body.company_code);
  fdata.append('urlfile', body.urlfile);
  fdata.append('description', body.description);
  fdata.append('user_id', body.user_id);
  fdata.append('dateCreated', moment().format("YYYY-MM-DD"));
  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });
  return request;
}

export function proccessUpload(fileupload, ext) {
  const url = `${ROOT_URL}fileupload/uploadfile/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);
  fdata.append("ext", ext);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
